export default "__VITE_ASSET__8f27d233__"